import type { IntlShape } from 'react-intl';

import { TicketStageType } from '~/enums/TicketStageType';

export const getStageConfig = (intl: IntlShape) => ({
  [TicketStageType.Edit]: {
    label: intl.formatMessage({
      id: 'ticket.stage.edit',
      defaultMessage: 'Edit',
      description: 'Ticket stage label for Edit',
    }),
    value: TicketStageType.Edit,
    order: 0,
  },
  [TicketStageType.Review]: {
    label: intl.formatMessage({
      id: 'ticket.stage.review',
      defaultMessage: 'Review',
      description: 'Ticket stage label for Review',
    }),
    value: TicketStageType.Review,
    order: 1,
  },
  [TicketStageType.Sign]: {
    label: intl.formatMessage({
      id: 'ticket.stage.sign',
      defaultMessage: 'Sign',
      description: 'Ticket stage label for Sign',
    }),
    value: TicketStageType.Sign,
    order: 2,
  },
  [TicketStageType.Finalize]: {
    label: intl.formatMessage({
      id: 'ticket.stage.finalize',
      defaultMessage: 'Finalize',
      description: 'Ticket stage label for Finalize',
    }),
    value: TicketStageType.Finalize,
    order: 3,
  },
  [TicketStageType.Ticket]: {
    label: intl.formatMessage({
      id: 'ticket.stage.ticket',
      defaultMessage: 'Ticket',
      description: 'Ticket stage label for Ticket',
    }),
    value: TicketStageType.Ticket,
    order: 100,
  },
});

export const TICKET_DOCUMENT_VERSION_EDITOR_KEY_POLLING_INTERVAL = 10000;
export const TICKET_DOCUMENT_VERSION_POLLING_MAX_COUNTER = 3;

export const FORM_INFO_TAB_INDEX = 1;

export const TICKET_NAMING_CONVENTION_ALLOWED_TYPES = [
  'DEPARTMENT',
  'USER',
  'DATE',
  'REFERENCE',
  'SHORT_RESPONSE',
  'SINGLE_SELECT',
];
export const TICKET_NAMING_CONVENTION_ALLOWED_IMPLICIT_TYPES = [
  'Paper Type',
  'Submitter Department',
  'Submitter Name',
  'Ticket Created Date',
  'Workflow Name',
];
